<template>
  <div v-if="params.value !== undefined && status" class="ag-table-cell-value-wrapper">
    <div class="ag-table-cell-value ag-table-device-status-renderer" :style="{color: status.color}">
      <app-icon v-if="status.icon" :name="status.icon" size="16px" class="ag-table-device-status-renderer__icon" />
      {{ status.name }}
    </div>
  </div>
</template>

<script>
import Vue            from 'vue';
import deviceStatuses from "@/dictionaries/deviceStatuses";

export default Vue.extend({
  name:     "StatusRenderer",
  data() {
    return {
      status: null,
    };
  },
  computed: {
    statusId() {
      const { data } = this.params;
      if (!data) return null;
      return data.actual_state;
    },
  },
  methods:  {
    loadStatus() {
      const { statusId } = this;
      if (typeof statusId !== "number") return this.status = null;
      deviceStatuses.getById(statusId).then(status => this.status = status);
    },
  },
  mounted() {
    this.loadStatus();
  },
  watch:    {
    statusId() {
      this.loadStatus();
    },
  },
});
</script>

<style lang="scss">
.ag-table-device-status-renderer {
  display: flex;
  align-items: center;
  /*justify-content: flex-start;*/

  &__icon {
    margin-right: 10px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>
